import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { PhoneIcon, ArrowRightIcon, StarIcon, CheckIcon } from 'lucide-react';
import { SITE } from '../lib/site';
import { SERVICES, STEPS } from '../lib/content';
import { QuoteForm } from '../components/QuoteForm';
import { WhyUs } from '../components/WhyUs';
import { CTABand } from '../components/CTABand';
import { SectionHeading } from '../components/SectionHeading';
export function Home() {
  return <>
      {/* HERO — phone-first opt-in */}
      <section className="relative overflow-hidden bg-black" data-id="element-178" data-mp="24hk6xchgnhkb">
        <img src="https://cdn.magicpatterns.com/patterns/generated-images/6847e4f5-0981-48e1-ab30-0820aa7e8e58.jpg" alt="Junk Kings crew loading a trailer behind a red Chevy Silverado" className="absolute inset-0 h-full w-full object-cover" data-id="element-179" data-mp="29fvj3tv8a45p" />
        <div className="absolute inset-0 bg-gradient-to-r from-jk-ink via-jk-ink/90 to-jk-ink/40" data-id="element-180" data-mp="3owlus84rvwu8" />
        <div className="absolute inset-y-0 left-0 w-1.5 bg-jk-red" data-id="element-181" data-mp="30wjdervucy5x" />

        <div className="relative mx-auto grid max-w-7xl gap-10 px-4 py-16 sm:px-6 lg:grid-cols-2 lg:py-24" data-id="element-182" data-mp="30up0o0uq4ccx">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.55
        }} className="flex flex-col justify-center" data-id="element-183" data-mp="2vvvoqcv34tev">
            <div className="mb-4 inline-flex w-fit items-center gap-2 rounded-full border border-jk-red/40 bg-jk-red/10 px-4 py-1.5" data-id="element-184" data-mp="2hxnkdjvpypto">
              <span className="h-2 w-2 rounded-full bg-jk-red" data-id="element-185" data-mp="2d6f90iatwudv" />
              <span className="font-display text-sm font-bold uppercase tracking-[0.2em] text-jk-silver" data-id="element-186" data-mp="287uhr8dk1l1k">
                Junk Removal · {SITE.area}
              </span>
            </div>
            <h1 className="font-display text-5xl font-extrabold uppercase leading-[0.92] tracking-tight text-white sm:text-7xl" data-id="element-187" data-mp="1z7fva5outzwh">
              You call.
              <br data-id="element-188" data-mp="1u9nwcrpsldis" />
              <span className="text-jk-red" data-id="element-189" data-mp="1uafqdy3qr36y">We haul.</span>
            </h1>
            <p className="mt-5 max-w-xl text-lg leading-relaxed text-white/75" data-id="element-190" data-mp="1kjxqz8f7f7al">
              Junk Kings clears out couches, appliances, garages, whole cleanouts — anything you need gone.
              Free estimates, upfront pricing, and the red truck shows up on time.
            </p>

            <div className="mt-7 flex flex-col gap-3 sm:flex-row" data-id="element-191" data-mp="1fmp2kq3gq70w">
              <a href={SITE.phoneHref} className="flex items-center justify-center gap-2 rounded-lg bg-jk-red px-6 py-3.5 font-display text-xl font-bold uppercase tracking-wide text-white transition-transform hover:scale-[1.03] hover:bg-jk-redDark sm:px-7 sm:py-4 sm:text-2xl" data-id="element-192" data-mp="23bgs19po4b9z">
                <PhoneIcon className="h-5 w-5 sm:h-6 sm:w-6" data-id="element-193" data-mp="1yjgjisvj8a1s" /> Call {SITE.phoneDisplay}
              </a>
              <Link to="/services" className="flex items-center justify-center gap-2 rounded-lg border-2 border-white/25 px-6 py-3.5 font-display text-xl font-bold uppercase tracking-wide text-white transition-colors hover:border-white hover:bg-white/5 sm:px-7 sm:py-4 sm:text-2xl" data-id="element-194" data-mp="2m91eka4ymxrf">
                Our Services
              </Link>
            </div>

            <div className="mt-7 flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-white/60" data-id="element-195" data-mp="od2qhm10e533">
              <span className="flex items-center gap-1.5" data-id="element-196" data-mp="kdlmkx18dg01">
                <StarIcon className="h-4 w-4 fill-jk-red text-jk-red" data-id="element-197" data-mp="3ss2ip6dzjzqq" /> 5-star local crew
              </span>
              <span className="flex items-center gap-1.5" data-id="element-198" data-mp="3ntsn4uocmx4l"><CheckIcon className="h-4 w-4 text-jk-red" data-id="element-199" data-mp="3nuu0j5su7vph" /> Free estimates</span>
              <span className="flex items-center gap-1.5" data-id="element-200" data-mp="5opb0pzytkuo"><CheckIcon className="h-4 w-4 text-jk-red" data-id="element-201" data-mp="5l9wppe48fub" /> Same-day service</span>
              <span className="flex items-center gap-1.5" data-id="element-202" data-mp="n8f78wc8oky"><CheckIcon className="h-4 w-4 text-jk-red" data-id="element-203" data-mp="1h2ji4hgt1hy9" /> Fully insured</span>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 24
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.55,
          delay: 0.15
        }} className="flex items-center" data-id="element-204" data-mp="1c2onq3xtma8g">
            <div className="w-full" data-id="element-205" data-mp="2cdhvfw87l9qf">
              <QuoteForm data-id="element-206" data-mp="2hc2lj2tqyd15" />
            </div>
          </motion.div>
        </div>
      </section>

      {/* SERVICES PREVIEW */}
      <section className="bg-white py-20" data-id="element-207" data-mp="2mbp1hk0ym7dn">
        <div className="mx-auto max-w-7xl px-4 sm:px-6" data-id="element-208" data-mp="2mcguqo733t0r">
          <SectionHeading light eyebrow="What We Haul" title={<>Big or small, <span className="text-jk-red" data-id="element-210" data-mp="2vb29075iwlvq">we take it all</span></>} subtitle="From a single couch to a full property cleanout, the Kings handle the heavy lifting." data-id="element-209" data-mp="2qdixhf07mn7h" />
          <div className="mt-12 grid gap-6 md:grid-cols-3" data-id="element-211" data-mp="3526or930warm">
            {SERVICES.map((s, i) => <motion.div key={s.slug} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="group overflow-hidden rounded-2xl border border-black/10 bg-white shadow-sm transition-shadow hover:shadow-xl" data-id="element-212" data-mp="3a19tstj06gzl" data-mpi={i}>
                <div className="relative h-48 overflow-hidden" data-id="element-213" data-mp="tds3i0suqeaa">
                  <img src={s.image} alt={s.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-214" data-mp="tg4uf3gl7yzh" />
                  <div className="absolute left-4 top-4 inline-flex h-11 w-11 items-center justify-center rounded-lg bg-jk-red text-white" data-id="element-215" data-mp="1m1xnumfzu19l">
                    <s.icon className="h-6 w-6" data-id="element-216" data-mp="1h5z4xedfpbgk" />
                  </div>
                </div>
                <div className="p-6" data-id="element-217" data-mp="1cbbh7hq98l31">
                  <h3 className="font-display text-2xl font-bold uppercase text-jk-ink" data-id="element-218" data-mp="17ecj6o3gztzk">{s.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-black/60" data-id="element-219" data-mp="24tyuwc2x8xu3">{s.blurb}</p>
                  <Link to="/services" className="mt-4 inline-flex items-center gap-1.5 font-display text-lg font-bold uppercase tracking-wide text-jk-red" data-id="element-220" data-mp="2030cn6ydhpo7">
                    Learn more <ArrowRightIcon className="h-4 w-4" data-id="element-221" data-mp="3ucp15nyi39qy" />
                  </Link>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className="bg-jk-panel py-20" data-id="element-222" data-mp="3kiydume415cu">
        <div className="mx-auto max-w-7xl px-4 sm:px-6" data-id="element-223" data-mp="3piu8hv0x3kfq">
          <SectionHeading eyebrow="How It Works" title={<>Four steps to a <span className="text-jk-red" data-id="element-225" data-mp="3al1whcukxe6a">clean space</span></>} data-id="element-224" data-mp="3amlaewsrjd4w" />
          <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4" data-id="element-226" data-mp="3fly8kdp346ms">
            {STEPS.map((step, i) => <motion.div key={step.n} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.08
          }} className="relative rounded-xl border border-white/10 bg-jk-ink p-6" data-id="element-227" data-mp="31myhz0i0hhnz" data-mpi={i}>
                <div className="font-display text-5xl font-extrabold text-jk-red" data-id="element-228" data-mp="14rak0zue7sy9">{step.n}</div>
                <h3 className="mt-2 font-display text-xl font-bold uppercase text-white" data-id="element-229" data-mp="1ev7eg2j0k3ja">{step.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-white/60" data-id="element-230" data-mp="1npvk3tsi3n8m">{step.text}</p>
              </motion.div>)}
          </div>
        </div>
      </section>

      <WhyUs data-id="element-231" data-mp="1ixvrkmerfwm2" />
      <CTABand data-id="element-232" data-mp="1ixc6wxxq6u4c" />
    </>;
}